import { render, staticRenderFns } from "./ReturnCustomerXsell.vue?vue&type=template&id=bed4b6b8&scoped=true&lang=pug&"
import script from "./ReturnCustomerXsell.vue?vue&type=script&lang=js&"
export * from "./ReturnCustomerXsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed4b6b8",
  null
  
)

export default component.exports